import type { LifeProcedure } from '@/types/general'
import { handleRequest, initialRequestState } from '@/utils/restStore'
import type { RequestState } from '@/utils/restStore'
import { defineStore } from 'pinia'

import Api from '@/services/api'

interface State {
  lifeProcedure: RequestState<LifeProcedure>
}

const initialState = (): State => ({
  lifeProcedure: initialRequestState()
})

export const useLifeProcedureStore = defineStore({
  id: 'life_procedure',
  state: initialState,
  actions: {
    async fetchLifeProcedure(uuid: String) {
      await handleRequest(
        () => Api.getLifeProcedure(uuid),
        (lifeProcedure: RequestState<LifeProcedure>) => {
          this.lifeProcedure = lifeProcedure
        }
      )
    }
  }
})
